import styled from "styled-components";
import {
  Type,
  Flex,
  DialogScroll,
  Divider,
} from "@ebscois/react-component-library";

export const ShareDialogTitle = styled(Type)`
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin-top: 0;
    margin-left: 0;
  }
`;

export const ShareDialogHint = styled.span`
  font-size: ${({ theme }) => theme.font.size.sm};
  font-weight: ${({ theme }) => theme.font.weight.light};
  font-style: italic;

  & > b {
    font-weight: bold;
  }
`;

export const ShareDialogContent = styled(DialogScroll)`
  margin: 0 ${({ theme }) => theme.space.xl} ${({ theme }) => theme.space.lg};

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    min-height: 200px;
    margin: 0 ${({ theme }) => theme.space.md} ${({ theme }) => theme.space.md};
  }
`;

export const ShareLinkLabel = styled.label`
  font-size: ${({ theme }) => theme.font.size.sm};
  font-weight: ${({ theme }) => theme.font.weight.light};

  & > b {
    font-weight: bold;

    span {
      text-transform: uppercase;
    }
  }
`;

export const ShareCopyLinkWrapper = styled(Flex)`
  ${({ isSingle, theme }) => `margin-left: ${isSingle ? "0" : theme.space.md};`}

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin-left: 0;
  }
`;

export const ShareLinkDescription = styled(Type)`
  font-size: ${({ theme }) => theme.font.size.sm};
  font-weight: ${({ theme }) => theme.font.weight.light};
  font-style: italic;

  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin-top: ${({ theme }) => theme.space.sm};
  }
`;

export const ShareDialogDivider = styled(Divider)`
  @media (max-width: ${({ theme }) => theme.breakpoints.sm}) {
    margin-top: 0.75rem;
    margin-bottom: 0.75rem;
  }
`;
